import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Phase 24 — клиент-сайд блокировка пользователей.
 *
 * Совпадает по поведению с Android `BlockedUsersStore` (DataStore Preferences):
 * блок только в UI, сервер ничего про него не знает. Сообщения заблокированных
 * пользователей мы просто фильтруем при рендере — сокет их всё равно принимает,
 * чтобы размер истории не деградировал при разблокировке.
 */
interface BlockedUsersState {
  ids: string[];
  isBlocked: (userId: string) => boolean;
  block: (userId: string) => void;
  unblock: (userId: string) => void;
  toggle: (userId: string) => void;
  clear: () => void;
}

export const useBlockedUsersStore = create<BlockedUsersState>()(
  persist(
    (set, get) => ({
      ids: [],
      isBlocked: (userId) => get().ids.includes(userId),
      block: (userId) =>
        set((s) => (s.ids.includes(userId) ? s : { ids: [...s.ids, userId] })),
      unblock: (userId) =>
        set((s) => ({ ids: s.ids.filter((id) => id !== userId) })),
      toggle: (userId) =>
        set((s) =>
          s.ids.includes(userId)
            ? { ids: s.ids.filter((id) => id !== userId) }
            : { ids: [...s.ids, userId] },
        ),
      clear: () => set({ ids: [] }),
    }),
    { name: 'irchat-blocked-users' },
  ),
);
